<template>
  <div id="primary-nav">
    <div class="flex-row flex-center">
      <span>www.thesewingarmy.com</span>
      <span class="logout" @click="logout()" v-if="global.loggedIn">
        <router-link :to="'/'">Log Out</router-link>
      </span>
    </div>
  </div>
</template>

<script>
import fire from "@/config/fire.js";
import { mapActions, mapState } from "vuex";
export default {
  name: "TopNav",
  computed: {
    ...mapState(["global"])
  },
  data() {
    return {};
  },
  methods: {
    logout() {
      fire.auth().signOut();
      this.setLoggedIn(false);
    },
    ...mapActions(["setLoggedIn"])
  }
};
</script>

<style lang="scss" scoped>
#primary-nav {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: $nav-height;
  background: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index: 99;
  background: rgba(0, 0, 0, 0.5);
  padding: 0 20px;
  @media (max-width: $sm) {
    flex-direction: column;
    height: $nav-height-mobile;
  }
  /**Adjust this padding for mobile, remove and justify center */

  .selected {
    background-image: #000000;
    box-shadow: inset 0 5px 10px 0 #000000;
  }
  > div {
    * {
      margin: 0 9px;
    }
    :first-child {
      margin-left: 0;
    }
    :last-child {
      margin-right: 0;
    }
  }
  b {
    font-size: 14px;
    color: #ffffff;
    letter-spacing: 0;
  }
  span {
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0;
  }
  .logout {
    cursor: pointer;
  }

  .primary-nav .flex-row {
    display: flex;
    flex-direction: row;
  }
  .flex-row {
    @media (max-width: $sm) {
      flex-direction: column !important;
    }
  }
  .flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>